(() => {
  const roots = document.querySelectorAll('[data-hof-root]');
  if (!roots.length) return;

  roots.forEach(async (root) => {
    if (root.dataset.hofReady === '1') return;
    root.dataset.hofReady = '1';

    const $ = (s, c = root) => c.querySelector(s);
    const $$ = (s, c = root) => [...c.querySelectorAll(s)];
    const esc = (v = '') => String(v).replace(/[&<>'"]/g, (m) => ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[m]));
    const fmt = (v) => Number(v || 0).toLocaleString();
    const initial = (name = 'HF') => name.split(/\s+/).filter(Boolean).slice(0,2).map(x => x[0]).join('').toUpperCase() || 'HF';
    const dateText = (date) => date ? new Intl.DateTimeFormat(undefined,{weekday:'short',month:'short',day:'numeric'}).format(new Date(date.length === 10 ? `${date}T12:00:00` : date)) : 'TBD';
    const rootUrl = (key, fallback = '#') => root.dataset[key] || fallback;
    let config = {};
    try { config = JSON.parse($('[data-hof-config]')?.textContent || '{}'); } catch (_) { config = {}; }
    const iconMedia = (item = {}, fallback = 'trophy') => item.iconImage
      ? `<img class="hof-custom-icon" src="${esc(item.iconImage)}" alt="">`
      : icon(item.fallbackIcon || fallback);
    const icon = (name) => {
      const paths = {
        gamepad: '<path d="M8 9h8a5 5 0 0 1 4.7 6.7l-1 2.7a2 2 0 0 1-3.3.8L14.6 17H9.4l-1.8 2.2a2 2 0 0 1-3.3-.8l-1-2.7A5 5 0 0 1 8 9Z"/><path d="M8 12v4m-2-2h4m6-1h.01M18 15h.01"/>',
        podium: '<path d="M3 20h18M5 20v-5h4v5m1 0V9h4v11m1 0v-8h4v8M11 6l1-3 1 3 3 .2-2.3 1.8.8 3-2.5-1.7L9.5 11l.8-3L8 6.2 11 6Z"/>',
        trophy: '<path d="M8 4h8v4c0 4-1.6 7-4 7s-4-3-4-7V4Zm2 11v3m4-3v3M8 20h8M6 6H3v2c0 2 1.5 3 4 3m11-5h3v2c0 2-1.5 3-4 3"/><path d="m12 6 .8 1.7 1.9.2-1.4 1.3.4 1.9-1.7-.9-1.7.9.4-1.9-1.4-1.3 1.9-.2L12 6Z"/>',
        fan: '<path d="M7 18v-1.5c0-2 2.2-3.5 5-3.5s5 1.5 5 3.5V18M12 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM4 11l-2-2m18 2 2-2M5 6 3 3m16 3 2-3"/>',
        handshake: '<path d="m3 12 4-4 4 2 2-1 4 3 4-1M5 14l3 3 2-1 2 2 2-1 2 1 4-4M8 8l2-2 4 1 2 2"/>',
        helmet: '<path d="M4 13a8 8 0 1 1 15 3h-5l-2-3H4Zm0 0h6v4H6a2 2 0 0 1-2-2v-2Zm14 3v3m0-1h3"/>',
        pin: '<path d="M12 21s6-5.3 6-11a6 6 0 1 0-12 0c0 5.7 6 11 6 11Z"/><circle cx="12" cy="10" r="2"/>',
        ticket: '<path d="M4 7h16v4a2 2 0 0 0 0 4v4H4v-4a2 2 0 0 0 0-4V7Zm7 0v12"/>',
        crew: '<path d="M8 12a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm8-1a2.5 2.5 0 1 0 0-5M2 19v-2c0-2.2 2.7-4 6-4s6 1.8 6 4v2m1-6c3 0 5 1.5 5 3.5V19"/>',
        plus: '<path d="M12 5v14M5 12h14"/>'
      };
      return `<svg viewBox="0 0 24 24" aria-hidden="true">${paths[name] || paths.trophy}</svg>`;
    };
    const crest = () => config.hero?.logo
      ? `<div class="hof-crest hof-crest--image"><img src="${esc(config.hero.logo)}" alt="HallOfFan"></div>`
      : `<div class="hof-crest" aria-label="HallOfFan"><span class="hof-laurel hof-laurel--left" aria-hidden="true"><i></i><i></i><i></i><i></i><i></i></span><div class="hof-crest-shield"><strong>HALL</strong><small>OF</small><strong>FAN</strong></div><span class="hof-laurel hof-laurel--right" aria-hidden="true"><i></i><i></i><i></i><i></i><i></i></span></div>`;

    if (root.dataset.fullscreen === 'true') document.body.classList.add('hof-fullscreen-page');

    const loading = $('[data-hof-loading]');
    const shell = $('[data-hof-shell]');
    const content = $('[data-hof-content]');
    const teamName = $('[data-hof-team-name]');
    const teamDot = $('[data-hof-team-dot]');
    const statusEl = $('[data-hof-status]');
    const accountBtn = $('[data-hof-account]');
    const authModal = $('[data-hof-auth-modal]');
    const nominationModal = $('[data-hof-nomination-modal]');
    const nominationForm = $('[data-hof-nomination-form]');

    const state = {
      view: 'home', session: null, user: null, context: null, stats: null,
      games: [], rankings: [], gameBreakdown: [], sponsors: [], defaultSchool: null
    };

    const waitForSupabase = async () => {
      for (let i = 0; i < 80; i++) {
        if (window.supabase?.createClient) return window.supabase;
        await new Promise(r => setTimeout(r, 50));
      }
      throw new Error('Supabase client did not load.');
    };

    let client;
    try {
      const lib = await waitForSupabase();
      client = lib.createClient(root.dataset.supabaseUrl, root.dataset.supabaseKey, {
        auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true }
      });
    } catch (e) {
      console.error('[HallOfFan] Supabase client failed to initialize:', e);
      if (statusEl) statusEl.textContent = 'Guest';
      if (accountBtn) accountBtn.textContent = 'Sign in';
      if (loading) loading.hidden = true;
      if (shell) shell.hidden = false;
      return;
    }

    const rpc = async (name, args = {}) => {
      const { data, error } = await client.rpc(name, args);
      if (error) throw error;
      return data;
    };

    const getDefaultSchool = async () => {
      const slug = root.dataset.defaultSchool || 'montana-state';
      const { data } = await client.from('fs_schools').select('id,slug,name,short_name,subdivision,conference_name').eq('slug', slug).eq('active', true).maybeSingle();
      state.defaultSchool = data || null;
    };

    const applyPendingProfile = async () => {
      if (!state.user) return;
      let pending;
      try { pending = JSON.parse(localStorage.getItem('hof_pending_profile') || 'null'); } catch (_) {}
      if (!pending) return;
      const patch = { display_name: pending.name || state.user.email?.split('@')[0] || 'Fan' };
      if (pending.school_id) patch.school_id = pending.school_id;
      const { error } = await client.from('fs_profiles').update(patch).eq('id', state.user.id);
      if (!error) localStorage.removeItem('hof_pending_profile');
    };

    const loadData = async () => {
      if (!state.session) {
        state.context = null; state.stats = null; state.games = []; state.rankings = []; state.sponsors = [];
        return;
      }
      await applyPendingProfile();
      let context = null;
      try { context = await rpc('fs_fan_portal_context'); } catch (_) {}
      state.context = context;
      const school = context?.school || state.defaultSchool;
      const schoolSlug = school?.slug || root.dataset.defaultSchool || 'montana-state';
      const jobs = [
        rpc('fs_my_fan_stats').catch(() => []),
        rpc('fs_game_center_catalog', { p_school_slug: schoolSlug }).catch(() => []),
        rpc('fs_competition_fanbase_leaderboard', { p_period:'season', p_season_key:null, p_subdivision:null, p_conference:null, p_limit:10, p_offset:0 }).catch(() => []),
        rpc('fs_my_game_breakdown', { p_period:'season', p_season_key:null }).catch(() => [])
      ];
      if (school?.id) jobs.push(rpc('fs_get_fanscore_sponsor_campaigns', { p_school_id:school.id, p_fan_game_id:null }).catch(() => []));
      const [stats, games, rankings, breakdown, sponsors = []] = await Promise.all(jobs);
      state.stats = Array.isArray(stats) ? stats[0] || null : stats;
      state.games = games || [];
      state.rankings = rankings || [];
      state.gameBreakdown = breakdown || [];
      state.sponsors = sponsors || [];
      trackSponsorImpressions();
    };

    const trackSponsorImpressions = () => {
      if (!state.session) return;
      state.sponsors.slice(0,4).forEach(c => {
        const k = `hof_imp_${c.campaign_id}`;
        if (sessionStorage.getItem(k)) return;
        sessionStorage.setItem(k,'1');
        rpc('fs_track_fanscore_sponsor_event',{p_campaign_id:c.campaign_id,p_event_type:'impression',p_event_value:null,p_metadata:{surface:'halloffan_home'}}).catch(()=>{});
      });
    };

    const header = (eyebrow, title, subtitle, actions = '') => `
      <div class="hof-view-header"><div><div class="hof-eyebrow">${esc(eyebrow)}</div><h1 class="hof-title">${esc(title)}</h1><p class="hof-subtitle">${esc(subtitle)}</p></div>${actions ? `<div class="hof-actions">${actions}</div>` : ''}</div>`;

    const sponsorBanner = () => {
      const s = state.sponsors.find(x => x.featured) || state.sponsors[0];
      if (!s) return '';
      return `<div class="hof-section-title"><h2>Presented on HallOfFan</h2></div><a class="hof-card hof-sponsor-banner" href="${esc(s.cta_url || '#')}" data-hof-sponsor-click="${esc(s.campaign_id)}" ${s.cta_url ? 'target="_blank" rel="noopener"' : ''}>
        ${s.creative_url || s.sponsor_logo_url ? `<img src="${esc(s.creative_url || s.sponsor_logo_url)}" alt="${esc(s.sponsor_name || 'Sponsor')}">` : ''}
        <div class="hof-sponsor-banner-copy"><small>Official challenge partner</small><strong>${esc(s.sponsor_name || s.campaign_name)}</strong><span>${esc(s.sponsor_message || s.campaign_name || '')}</span></div><span class="hof-sponsor-cta">${s.cta_url ? 'Visit sponsor →' : 'Presented by HallOfFan'}</span></a>`;
    };

    const gameCards = (limit = 8) => {
      const items = state.games.slice(0, limit);
      if (!items.length) return `<div class="hof-card hof-empty">No games are enabled for this team yet.</div>`;
      return `<div class="hof-grid hof-grid-4">${items.map(g => `<article class="hof-card hof-game-card">
        <div class="hof-game-top"><span class="hof-game-seal">${esc(initial(g.name))}</span><span class="hof-points">+${fmt(g.fanscore_points_per_play)} / PLAY</span></div>
        <div><span class="hof-badge">Connected game</span><h3 style="margin-top:8px">${esc(g.name)}</h3><p>Your result posts into the same connected Fan Score ledger.</p></div>
        <div class="hof-game-go"><a class="hof-play-link" href="${esc(g.launch_url || `/pages/${g.handle}`)}">Enter game</a><span class="hof-badge">Live</span></div>
      </article>`).join('')}</div>`;
    };

    const tools = () => `<div class="hof-tool-grid">
      <a class="hof-tool-card" href="${esc(rootUrl('parkingUrl'))}"><span class="hof-tool-icon">${icon('pin')}</span><span><strong>Parking Map</strong><br><span>Lots, meetups & fan zones</span></span></a>
      <a class="hof-tool-card" href="${esc(rootUrl('ticketsUrl'))}"><span class="hof-tool-icon">${icon('ticket')}</span><span><strong>Ticket Exchange</strong><br><span>Fan-to-fan listings</span></span></a>
      <a class="hof-tool-card" href="${esc(rootUrl('tailgatesUrl'))}"><span class="hof-tool-icon">${icon('crew')}</span><span><strong>My Crew</strong><br><span>Assignments & tailgates</span></span></a>
      <a class="hof-tool-card" href="${esc(rootUrl('tailgatesUrl'))}"><span class="hof-tool-icon">${icon('plus')}</span><span><strong>Crew Applications</strong><br><span>Find public tailgates</span></span></a>
    </div>`;

    const renderPublic = () => {
      const hero = config.hero || {};
      const score = config.score || {};
      const scoreStats = (config.scoreStats?.length ? config.scoreStats : [
        {title:'Play',label:'Games',fallbackIcon:'gamepad'},
        {title:'Climb',label:'Rankings',fallbackIcon:'podium'},
        {title:'Earn',label:'Rewards',fallbackIcon:'trophy'}
      ]).slice(0,3);
      const howCards = (config.howCards?.length ? config.howCards : [
        {title:'Fans Play',body:'Trivia, predictions, rivalry challenges, gameday actions and live competitions all feed one score.',fallbackIcon:'fan'},
        {title:'Advertisers Pay',body:'Sponsor artwork follows the correct school, game and placement while interactions are measured automatically.',fallbackIcon:'handshake'},
        {title:'Players Earn',body:'Athlete participation and campaign value connect fan activity back to athlete opportunities and earnings.',fallbackIcon:'helmet'}
      ]).slice(0,3);
      const nomination = config.nomination || {};
      content.classList.add('hof-content--public');
      content.innerHTML = `<div class="hof-public">
        <section class="hof-public-screen hof-public-screen--intro">
          <section class="hof-public-hero">
            <div class="hof-public-copy">
              ${crest()}
              <div class="hof-eyebrow hof-hero-kicker">${esc(hero.kicker || 'College sports belongs to the fans')}</div>
              <h1><span>${esc(hero.line1 || 'Earn your')}</span><span>${esc(hero.line2 || 'place in the')}</span><em>${esc(hero.line3 || 'HallOfFan.')}</em></h1>
              <div class="hof-hero-stars" aria-hidden="true">★ ★ ★ ★ ★</div>
              <p>${esc(hero.body || '')}</p>
              <div class="hof-actions"><button class="hof-primary-button" data-hof-open-auth="signup">${esc(hero.joinLabel || 'Join HallOfFan')}</button><button class="hof-secondary-button" data-hof-open-auth="signin">${esc(hero.signInLabel || 'Sign in')}</button></div>
            </div>
          </section>
          <section class="hof-public-board" aria-label="How your Fan Score works">
            <div class="hof-public-score"><small>${esc(score.heading || 'Your Fan Score')}</small><div class="hof-score-laurel"><strong>0</strong></div><span>${esc(score.subheading || 'Start your legacy')}</span></div>
            ${scoreStats.map((item, idx) => `<div class="hof-public-stat"><span class="hof-public-stat-icon">${iconMedia(item, ['gamepad','podium','trophy'][idx] || 'trophy')}</span><strong>${esc(item.title || '')}</strong><span>${esc(item.label || '')}</span></div>`).join('')}
          </section>
          <div class="hof-scroll-cue" aria-hidden="true"><span>Scroll once</span><b>↓</b></div>
        </section>

        <section class="hof-public-screen hof-public-screen--community">
          <div class="hof-public-community-inner">
            <h2 class="hof-how-heading">${esc(config.howHeading || 'How HallOfFan Works')}</h2>
            <section class="hof-how">
              ${howCards.map((item, idx) => `<div class="hof-how-card"><span class="hof-how-medallion">${iconMedia(item, ['fan','handshake','helmet'][idx] || 'fan')}</span><b>${esc(item.title || '')}</b><span>${esc(item.body || '')}</span></div>`).join('')}
            </section>
            ${nomination.show !== false ? `<section class="hof-nominate-section">
              <div class="hof-nominate-copy"><div class="hof-eyebrow">${esc(nomination.eyebrow || '')}</div><h2>${esc(nomination.heading || 'Nominate a Fan for the Hall')}</h2><p>${esc(nomination.body || '')}</p></div>
              <button class="hof-primary-button hof-nominate-button" type="button" data-hof-open-nomination>${esc(nomination.button || 'Nominate a Fan')}</button>
            </section>` : ''}
          </div>
        </section>
      </div>`;
    };

    const renderHome = () => {
      const ctx = state.context || {};
      const school = ctx.school || state.defaultSchool || {};
      const next = ctx.next_game || null;
      const st = state.stats || {};
      const score = st.fan_score || 0;
      const challengeTitle = next ? `${next.team_name || school.name || 'Your Team'} vs ${next.opponent_name || 'Opponent'}` : `${school.name || 'Your Team'} Weekly Challenge`;
      const challengeUrl = rootUrl('challengeUrl', state.games[0]?.launch_url || '#');
      content.innerHTML = header('Your fan command center','Game day starts here.','Compete, climb the board, organize your crew and support athlete-powered experiences without bouncing between disconnected pages.',`<button class="hof-primary-button" data-hof-view="compete">Play now</button><button class="hof-secondary-button" data-hof-view="gameday">Open Tailgate HQ</button>`)
      + `<div class="hof-grid hof-grid-3"><section class="hof-card hof-score-card"><div class="hof-eyebrow">My Fan Score</div><div class="hof-big-score">${fmt(score)}</div><div class="hof-score-label">POINTS</div><div class="hof-stat-row"><div><b>${fmt(st.games_attended)}</b><span>Games</span></div><div><b>${fmt(st.stadiums_visited)}</b><span>Stadiums</span></div><div><b>${fmt(st.miles_traveled)}</b><span>Miles</span></div></div></section>
      <section class="hof-card hof-challenge-card"><div><div class="hof-eyebrow">This week's Tailgate Challenge</div><h2 class="hof-challenge-title">${esc(challengeTitle)}</h2><div class="hof-match"><div class="hof-match-badge">${esc(initial(school.name || 'TEAM'))}</div><div><b>${esc(school.short_name || school.name || 'Your Team')}</b><div style="font-size:11px;opacity:.62">Build fan power</div></div><div class="hof-match-vs">VS</div><div><b>${esc(next?.opponent_name || 'The field')}</b><div style="font-size:11px;opacity:.62">Rival fans</div></div></div></div><div><div class="hof-progress"><span></span></div><a class="hof-dark-button" href="${esc(challengeUrl)}">Tap to compete</a></div></section></div>`
      + sponsorBanner()
      + `<div class="hof-section-title"><h2>Game Center</h2><button class="hof-text-button" data-hof-view="compete">See all games →</button></div>${gameCards(8)}`
      + `<div class="hof-section-title"><h2>Tailgate HQ</h2><button class="hof-text-button" data-hof-view="gameday">Open hub →</button></div>${tools()}`
      + leaderboardPreview();
    };

    const leaderboardPreview = () => {
      if (!state.rankings.length) return '';
      return `<div class="hof-section-title"><h2>Fanbase leaderboard</h2><button class="hof-text-button" data-hof-view="rankings">Full rankings →</button></div><div class="hof-card hof-table-wrap"><table class="hof-table"><thead><tr><th>Rank</th><th>School</th><th>Competition Score</th><th>Fans</th><th>Plays</th></tr></thead><tbody>${state.rankings.slice(0,5).map(r=>`<tr><td class="hof-rank-cell">#${r.rank}</td><td><b>${esc(r.school_name)}</b><br><span style="color:var(--hof-muted);font-size:10px">${esc(r.subdivision || '')}</span></td><td class="hof-table-score">${fmt(r.competition_score)}</td><td>${fmt(r.active_fans)}</td><td>${fmt(r.plays_count)}</td></tr>`).join('')}</tbody></table></div>`;
    };

    const renderCompete = () => {
      content.innerHTML = header('Compete','Every game. One Fan Score.','Pick a game. Your completed play flows through the existing FanScore scoring bridge and immediately becomes part of HallOfFan rankings.',`<button class="hof-secondary-button" data-hof-view="home">Back home</button>`)
        + gameCards(100)
        + `<div class="hof-section-title"><h2>Your season by game</h2></div>${state.gameBreakdown.length ? `<div class="hof-card hof-table-wrap"><table class="hof-table"><thead><tr><th>Game</th><th>Fan Score</th><th>Plays</th><th>Best</th><th>Last played</th></tr></thead><tbody>${state.gameBreakdown.map(r=>`<tr><td><b>${esc(r.game_name)}</b></td><td class="hof-table-score">${fmt(r.fanscore_points)}</td><td>${fmt(r.plays_count)}</td><td>${r.best_raw_score ?? '—'}</td><td>${r.last_played_at ? dateText(r.last_played_at) : '—'}</td></tr>`).join('')}</tbody></table></div>` : `<div class="hof-card hof-empty">Play your first connected game to start the breakdown.</div>`}`;
    };

    const renderRankings = () => {
      content.innerHTML = header('Rankings','Make your fanbase matter.','The leaderboard reads the same score ledger as every connected HallOfFan game. No separate sync, no duplicate scoring.',`<button class="hof-secondary-button" data-hof-view="home">Back home</button>`)
        + (state.rankings.length ? `<div class="hof-card hof-table-wrap"><table class="hof-table"><thead><tr><th>Rank</th><th>Fanbase</th><th>Competition Score</th><th>Total Points</th><th>Active Fans</th><th>Avg Fan Score</th></tr></thead><tbody>${state.rankings.map(r=>`<tr><td class="hof-rank-cell">#${r.rank}</td><td><b>${esc(r.school_name)}</b><br><span style="font-size:10px;color:var(--hof-muted)">${esc([r.subdivision,r.conference_name].filter(Boolean).join(' · '))}</span></td><td class="hof-table-score">${fmt(r.competition_score)}</td><td>${fmt(r.total_points)}</td><td>${fmt(r.active_fans)}</td><td>${fmt(r.average_fan_score)}</td></tr>`).join('')}</tbody></table></div>` : `<div class="hof-card hof-empty">Rankings will populate as fans score points.</div>`);
    };

    const renderGameday = () => {
      const ctx = state.context || {}, next = ctx.next_game, st = ctx.stats || {};
      content.innerHTML = header('Gameday','Everything around the game.','Parking, tickets, tailgates, check-ins and your crew stay attached to the same event instead of living in separate systems.',`<button class="hof-secondary-button" data-hof-view="home">Back home</button>`)
      + (next ? `<div class="hof-card hof-event-card"><div><div class="hof-eyebrow">Our next game</div><h2 style="font-size:28px;margin-top:5px">${esc(next.team_name || 'Your Team')} vs ${esc(next.opponent_name)}</h2><div class="hof-event-meta">${esc(dateText(next.kickoff_at || next.game_date))}${next.kickoff_display ? ` · ${esc(next.kickoff_display)}` : ''}<br>${esc(next.venue_name || 'Venue TBD')}${next.city ? ` · ${esc(next.city)}` : ''}${next.tv_network ? `<br>TV: ${esc(next.tv_network)}` : ''}</div></div><a class="hof-primary-button" href="${esc(rootUrl('challengeUrl','#'))}">Compete this week</a></div>` : `<div class="hof-card hof-empty">No upcoming game is currently attached to your team.</div>`)
      + `<div class="hof-section-title"><h2>Tailgate HQ</h2></div>${tools()}`
      + `<div class="hof-section-title"><h2>Your gameday activity</h2></div><div class="hof-kpis"><div class="hof-kpi"><span>Check-ins</span><b>${fmt(st.checkins)}</b></div><div class="hof-kpi"><span>Tailgates</span><b>${fmt(st.tailgates)}</b></div><div class="hof-kpi"><span>Tickets listed</span><b>${fmt(st.ticket_listings)}</b></div><div class="hof-kpi"><span>Parking</span><b>${fmt(st.parking_reservations)}</b></div></div>`;
    };

    const renderProfile = () => {
      const p = state.context?.profile || {}, s = state.context?.school || state.defaultSchool || {}, st = state.stats || {};
      content.innerHTML = header('My HallOfFan','Your fan identity.','One account connects your team, game activity, gameday history and leaderboard score.',`<button class="hof-secondary-button" data-hof-view="home">Back home</button>`)
        + `<div class="hof-grid hof-grid-2"><div class="hof-card"><div class="hof-eyebrow">Profile</div><h2 style="font-size:28px;margin-top:6px">${esc(p.display_name || state.user?.email || 'Fan')}</h2><p>${esc(s.name || 'No team selected')}</p><div class="hof-callout"><strong>Team connection:</strong> your school ID keeps games, Fan Score, rankings and gameday attached to the same identity.</div><div class="hof-workspace-links"><a href="${esc(rootUrl('athleteUrl'))}">Athlete workspace <span>→</span></a><a href="${esc(rootUrl('sponsorUrl'))}">Sponsor workspace <span>→</span></a><a href="${esc(rootUrl('adminUrl'))}">Admin workspace <span>→</span></a></div></div><div class="hof-card hof-score-card"><div class="hof-eyebrow">Lifetime Fan Score</div><div class="hof-big-score">${fmt(st.fan_score)}</div><div class="hof-stat-row"><div><b>${fmt(st.road_games)}</b><span>Road</span></div><div><b>${fmt(st.rivalry_games)}</b><span>Rivalry</span></div><div><b>${fmt(st.postseason_games)}</b><span>Postseason</span></div></div></div></div>`;
    };

    const render = () => {
      if (!state.session) renderPublic();
      else {
        content.classList.remove('hof-content--public');
        if (state.view === 'compete') renderCompete();
        else if (state.view === 'rankings') renderRankings();
        else if (state.view === 'gameday') renderGameday();
        else if (state.view === 'profile') renderProfile();
        else renderHome();
      }
      $$('.hof-nav button').forEach(b => b.classList.toggle('is-active', b.dataset.hofView === state.view));
      bindDynamic();
      updateTopbar();
    };

    const updateTopbar = () => {
      const school = state.context?.school || state.defaultSchool;
      teamName.textContent = school?.name || 'Choose a team';
      teamDot.textContent = initial(school?.name || 'HF');
      statusEl.textContent = state.session ? 'Fan Score synced' : 'Guest';
      accountBtn.textContent = state.session ? 'Sign out' : 'Sign in';
    };

    const setView = (view) => { state.view = view; render(); content.scrollTo({top:0,behavior:'smooth'}); };

    const openAuth = (tab = 'signin') => {
      authModal.hidden = false;
      setAuthTab(tab);
      const form = tab === 'signup' ? $('[data-hof-signup]') : $('[data-hof-signin]');
      const email = form?.querySelector('input[name="email"]');
      if (email && !email.value && root.dataset.shopifyEmail) email.value = root.dataset.shopifyEmail;
      setTimeout(()=>form?.querySelector('input')?.focus(),40);
    };
    const closeAuth = () => { authModal.hidden = true; };
    const openNomination = () => {
      if (!nominationModal) return;
      nominationModal.hidden = false;
      const email = nominationForm?.querySelector('input[name="nominator_email"]');
      const name = nominationForm?.querySelector('input[name="nominator_name"]');
      const school = nominationForm?.querySelector('input[name="nominee_school"]');
      if (email && !email.value) email.value = state.user?.email || root.dataset.shopifyEmail || '';
      if (name && !name.value) name.value = state.context?.profile?.display_name || '';
      if (school && !school.value) school.value = state.context?.school?.name || state.defaultSchool?.name || '';
      setTimeout(()=>nominationForm?.querySelector('input')?.focus(),40);
    };
    const closeNomination = () => { if (nominationModal) nominationModal.hidden = true; };
    const setAuthTab = (tab) => {
      $$('[data-hof-auth-tab]').forEach(b=>b.classList.toggle('is-active',b.dataset.hofAuthTab===tab));
      $('[data-hof-signin]').hidden = tab !== 'signin';
      $('[data-hof-signup]').hidden = tab !== 'signup';
    };

    const bindDynamic = () => {
      $$('[data-hof-view]', content).forEach(el => el.addEventListener('click', e => { e.preventDefault(); setView(el.dataset.hofView); }));
      $$('[data-hof-open-auth]', content).forEach(el => el.addEventListener('click', () => openAuth(el.dataset.hofOpenAuth)));
      $$('[data-hof-open-nomination]', content).forEach(el => el.addEventListener('click', openNomination));
      $$('[data-hof-sponsor-click]', content).forEach(el => el.addEventListener('click', () => rpc('fs_track_fanscore_sponsor_event',{p_campaign_id:el.dataset.hofSponsorClick,p_event_type:'click',p_event_value:null,p_metadata:{surface:'halloffan_home'}}).catch(()=>{})));
    };

    $$('[data-hof-view]', root).filter(el=>!content.contains(el)).forEach(el=>el.addEventListener('click',e=>{e.preventDefault();setView(el.dataset.hofView);}));
    $$('[data-hof-close-auth]').forEach(el=>el.addEventListener('click',closeAuth));
    $$('[data-hof-close-nomination]').forEach(el=>el.addEventListener('click',closeNomination));
    $$('[data-hof-auth-tab]').forEach(el=>el.addEventListener('click',()=>setAuthTab(el.dataset.hofAuthTab)));
    accountBtn.addEventListener('click', async()=>{ if(state.session){await client.auth.signOut();} else openAuth('signin'); });

    const schoolSearch = $('[data-hof-signup] input[name="school_search"]');
    const schoolId = $('[data-hof-signup] input[name="school_id"]');
    const schoolResults = $('[data-hof-school-results]');
    let schoolTimer;
    schoolSearch.addEventListener('input',()=>{
      schoolId.value=''; clearTimeout(schoolTimer); const q=schoolSearch.value.trim();
      if(q.length<2){schoolResults.hidden=true;return;}
      schoolTimer=setTimeout(async()=>{
        const {data}=await client.from('fs_schools').select('id,name,slug,subdivision,conference_name').eq('active',true).ilike('name',`%${q.replace(/[%_]/g,'')}%`).order('name').limit(24);
        schoolResults.innerHTML=(data||[]).map(s=>`<button type="button" class="hof-school-option" data-school-id="${esc(s.id)}" data-school-name="${esc(s.name)}">${esc(s.name)}<small>${esc([s.subdivision,s.conference_name].filter(Boolean).join(' · '))}</small></button>`).join('')||'<div class="hof-empty">No schools found.</div>';
        schoolResults.hidden=false;
        $$('[data-school-id]',schoolResults).forEach(btn=>btn.addEventListener('click',()=>{schoolId.value=btn.dataset.schoolId;schoolSearch.value=btn.dataset.schoolName;schoolResults.hidden=true;}));
      },250);
    });

    $('[data-hof-signin]').addEventListener('submit',async e=>{
      e.preventDefault(); const form=e.currentTarget, err=$('[data-hof-signin-error]'); err.textContent='';
      const fd=new FormData(form); const submit=form.querySelector('button[type="submit"]'); submit.disabled=true; submit.textContent='Signing in…';
      const {error}=await client.auth.signInWithPassword({email:String(fd.get('email')).trim(),password:String(fd.get('password'))});
      if(error) err.textContent=error.message; else closeAuth(); submit.disabled=false;submit.textContent='Sign in';
    });

    $('[data-hof-signup]').addEventListener('submit',async e=>{
      e.preventDefault(); const form=e.currentTarget, err=$('[data-hof-signup-error]'); err.textContent='';
      const fd=new FormData(form); if(!fd.get('school_id')){err.textContent='Choose a school from the search results.';return;}
      const profile={name:String(fd.get('name')).trim(),school_id:String(fd.get('school_id'))}; localStorage.setItem('hof_pending_profile',JSON.stringify(profile));
      const submit=form.querySelector('button[type="submit"]'); submit.disabled=true;submit.textContent='Creating account…';
      const {data,error}=await client.auth.signUp({email:String(fd.get('email')).trim(),password:String(fd.get('password')),options:{data:{display_name:profile.name}}});
      if(error){err.textContent=error.message;localStorage.removeItem('hof_pending_profile');}
      else if(data.session){closeAuth();}
      else {err.style.color='var(--hof-green)';err.textContent='Account created. Check your email to confirm, then sign in.';setAuthTab('signin');}
      submit.disabled=false;submit.textContent='Create fan account';
    });

    if (nominationForm) nominationForm.addEventListener('submit', async e => {
      e.preventDefault();
      const form = e.currentTarget;
      const err = $('[data-hof-nomination-error]');
      err.style.color = '';
      err.textContent = '';
      const fd = new FormData(form);
      if (String(fd.get('website') || '').trim()) return;
      const submit = form.querySelector('button[type="submit"]');
      submit.disabled = true;
      const original = submit.textContent;
      submit.textContent = 'Submitting…';
      const school = state.context?.school || state.defaultSchool || null;
      const payload = {
        nominee_name: String(fd.get('nominee_name') || '').trim(),
        nominee_email: String(fd.get('nominee_email') || '').trim() || null,
        nominee_school: String(fd.get('nominee_school') || '').trim(),
        nominee_city_state: String(fd.get('nominee_city_state') || '').trim() || null,
        reason: String(fd.get('reason') || '').trim(),
        nominator_name: String(fd.get('nominator_name') || '').trim(),
        nominator_email: String(fd.get('nominator_email') || '').trim(),
        nominator_user_id: state.user?.id || null,
        school_id: school?.id || null,
        source_path: location.pathname,
        metadata: { school_slug: school?.slug || null, surface: 'halloffan_public' }
      };
      const { error } = await client.from('hof_fan_nominations').insert(payload);
      if (error) {
        err.textContent = error.message.includes('hof_fan_nominations') ? 'Nomination storage is not installed yet. Run the HallOfFan v1.4 Supabase migration.' : error.message;
      } else {
        err.style.color = 'var(--hof-green)';
        err.textContent = 'Nomination received. Thank you for helping build the Hall.';
        form.reset();
        setTimeout(closeNomination, 1200);
      }
      submit.disabled = false;
      submit.textContent = original;
    });

    client.auth.onAuthStateChange(async (_event, session)=>{
      state.session=session; state.user=session?.user||null;
      await loadData(); render();
    });

    await getDefaultSchool();
    const {data:{session}}=await client.auth.getSession();
    state.session=session; state.user=session?.user||null;
    await loadData();
    if (loading) loading.hidden=true; if (shell) shell.hidden=false; render();
  });
})();
